module.exports = __webpack_public_path__ + "static/barcode-scanner-efd7776e882ce5e126f6e52b10d6f146.png";